import { AfterViewInit, Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray, AbstractControl } from '@angular/forms';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { MedigapMedicationsForm, MedigapMedicationsFormControlsInterface } from 'src/app/shared/interfaces/application-retrieval/retrieveApp.interface';
import { MedigapMedicationsStateStructure } from 'src/app/shared/reducers/medigap-medications.reducer';

@FormComponentLookup('health-check-medication')
@Component({
    selector: 'app-health-check-medication',
    templateUrl: './health-check-medication.component.html',
    styleUrls: ['./health-check-medication.component.scss'],
    standalone: false
})
export class HealthCheckMedicationComponent extends FormEntryComponentClass implements AfterViewInit {

  medicationForm: UntypedFormGroup;
  isValid = false;

  /** Allows typed controls */
  get medFormControls(): MedigapMedicationsFormControlsInterface {
    return this.medicationForm.controls as unknown as MedigapMedicationsFormControlsInterface;
  }

  /** Allows typed value retrieval */
  get formValuesAsJson(): MedigapMedicationsForm {
    return this.medicationForm.value;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private reducerUtilService: ReducerUtilityService
  ) {
    super();
    this.createForm();
  }

  ngOnInit() {
    this.medicationForm.get('medications').valueChanges.subscribe(values => {
      this.updateValidity(values);
    })
  }

  ngAfterViewInit() {
    console.log('AfterView Init');
    const formControl: AbstractControl = this.formControls[this.entry.formControlAttributes.formControlName];
    
    formControl.setValidators((control: AbstractControl) => {
      console.log("validator this.isValid", this.isValid);
      return (this.entry.base.display && this.isValid) ? null : {'medicationError': true};
    });

    formControl.updateValueAndValidity();
    this.subscribeToFormStream(this.entry.base.formListeners);
  }

  updateValidity(medicationsFormValues) {
    const enrollmentMedication = this.reducerUtilityService.getPayloadStates().MedigapEnrollmentMedications;
    if(enrollmentMedication.medicationForm.isPrescribedMeds === 'Yes') {
      medicationsFormValues.forEach(med => {
        if(med.medicationName && med.medicationDosage && med.conditionForMed && med.currentlyTaking) {
          this.isValid = true;
          console.log('this.isValid',this.isValid);
        } else {
          this.isValid = false;
        }
      })
    } else {
      this.isValid = true;
    }

    const formControl: AbstractControl = this.formControls[this.entry.formControlAttributes.formControlName];
    formControl.updateValueAndValidity();
  }

  private generateBlankMedRow() {
    return this.formBuilder.group({
      medicationName: this.formBuilder.control(null, Validators.required),
      medicationDosage: this.formBuilder.control(null, Validators.required),
      conditionForMed: this.formBuilder.control(null, Validators.required),
      currentlyTaking: this.formBuilder.control(null, Validators.required)
    });
  }

  addMedication() {
    (this.medFormControls.medications as UntypedFormArray).push(this.generateBlankMedRow());
  }

  removeMedication(i: number) {
    (this.medFormControls.medications as UntypedFormArray).removeAt(i);
  }

  createForm() {
    this.medicationForm = this.formBuilder.group({
      medications: this.formBuilder.array([])
    });

    let stateDefinedArraySize = 0;
    const currentState = this.reducerUtilService.getPayloadState<MedigapMedicationsStateStructure>('MedigapEnrollmentMedications');

    if (
      currentState &&
      currentState.medicationForm &&
      currentState.medicationForm.medications
    ) {
      stateDefinedArraySize = currentState.medicationForm.medications.length;
    }

    for (let i = 0; i < stateDefinedArraySize; i++) {
      (this.medicationForm.get('medications') as UntypedFormArray).push(
        this.formBuilder.group({
          medicationName: this.formBuilder.control(null, Validators.required),
          medicationDosage: this.formBuilder.control(null, Validators.required),
          conditionForMed: this.formBuilder.control(null, Validators.required),
          currentlyTaking: this.formBuilder.control(null, Validators.required)
        })
      );
    }
  }

}